import { render, staticRenderFns } from "./AbaEditarDadosPermissoesUsuario.vue?vue&type=template&id=42ec6c4d"
import script from "./AbaEditarDadosPermissoesUsuario.vue?vue&type=script&lang=ts"
export * from "./AbaEditarDadosPermissoesUsuario.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports